import React, { useState, useEffect } from "react";
import "./Slider.scss";

const Slide = ({ item }) => {
  const styles = {
    backgroundImage: `url(${item.img})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    width: "100%",
    height: "100%",
  };

  return (
    <div className="slide" style={styles}>
      <div className="slide_content">
        {item.title && <h1 className="slide-title">{item.title}</h1>}
        {item.subtitle && <p className="slide-subtitle">{item.subtitle}</p>}

        <div className="btn-group">
          <button className="cta-btn">Get Quote</button>
          <button className="chk-price-btn">View Projects</button>
        </div>
      </div>
    </div>
  );
};

const Slider = ({ slides }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [translateValue, setTranslateValue] = useState(0);

  const handleDotClick = (index) => {
    setCurrentIndex(index);
    setTranslateValue(-index * 100);
  };

  useEffect(() => {
    const slider = setInterval(() => {
      const nextIndex = currentIndex < slides.length - 1 ? currentIndex + 1 : 0;
      setCurrentIndex(nextIndex);
      setTranslateValue(-nextIndex * 100);
    }, 5000);

    return () => clearInterval(slider);
  }, [currentIndex, slides.length]);

  return (
    <div className="slider">
      <div
        className="slider_wrapper"
        style={{ transform: `translateX(${translateValue}%)` }}
      >
        {slides.map((item) => (
          <Slide key={item.id} item={item} />
        ))}
      </div>

      <div className="dots_wrapper">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`dot ${currentIndex === index ? "active" : ""}`}
            onClick={() => handleDotClick(index)}
          >
            ●
          </span>
        ))}
      </div>
    </div>
  );
};

export default Slider;
